export default __webpack_public_path__ + "static/media/RipplingEssence.0f2cbee5.JPG";